import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';
import { setupGlobalErrorHandling, isExtensionRelatedError } from './utils/errorHandler';

// 添加全局API配置类型定义
declare global {
  interface Window {
    API_CONFIG?: {
      baseURL: string;
    };
    resetApiUrl?: () => boolean;
  }
}

// 配置全局API基础URL
if (window.API_CONFIG && window.API_CONFIG.baseURL) {
  axios.defaults.baseURL = window.API_CONFIG.baseURL;
  console.log('已配置API基础URL:', axios.defaults.baseURL);
} else {
  console.log('使用相对路径API地址');
}

// 配置默认超时时间
axios.defaults.timeout = 10000; // 10秒

// 设置全局错误处理
setupGlobalErrorHandling();

// 配置全局错误处理
axios.interceptors.response.use(
  response => response,
  error => {
    // 网络错误特殊处理
    if (!error.response) {
      console.error('网络错误或API服务器未响应:', error.message);
    }
    
    // 过滤掉可能由浏览器扩展引起的错误
    if (isExtensionRelatedError(error)) {
      // 静默处理这些错误，不向上传播
      console.warn('检测到浏览器扩展相关错误，已忽略:', error.message);
      return Promise.resolve({ data: null, status: 0 });
    }
    
    return Promise.reject(error);
  }
);

// 主应用立即渲染
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // 开发环境中移除严格模式双重渲染以提高性能
  process.env.NODE_ENV === 'production' ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

// 延迟加载非关键模块
const loadNonCriticalModules = () => {
  import('./reportWebVitals').then(({ default: reportWebVitals }) => {
    // 性能报告在用户交互后再执行
    reportWebVitals();
  });
};

// 在页面加载完成后延迟执行非关键操作
if (document.readyState === 'complete') {
  loadNonCriticalModules();
} else {
  window.addEventListener('load', loadNonCriticalModules);
}
